import { useQuery } from "@tanstack/react-query";
import { validate } from "uuid";
import { getCountries, getCountry } from "../api";

export const useCountries = (filters) =>
	useQuery({
		queryFn: () => getCountries(filters),
		queryKey: ["Countries", filters],
	});

export const useCountry = (id?: Country["id"]) =>
	useQuery({
		queryFn: () => getCountry(id),
		enabled: !!validate(id),
		queryKey: ["Countries", { id }],
	});
